


























import Vue from 'vue'
import subscribeBots from '@/mixins/SubscribeBots'
import { KeyDict } from '@/types'
import { Bot, BotAction } from '@/types/bots'
import { Input, Button } from 'element-ui'
import { Cast } from '@/types/casts'

export default Vue.extend({
  name: 'BotsMessages',
  mixins: [ subscribeBots ],
  data: () => ({
    actionValues: {} as KeyDict<KeyDict<KeyDict<number>>>
  }),
  mounted () {
    this.updateParams()
  },
  computed: {
    currentCast (): Cast {
      return this.$store.direct.state.events.currentCast
    },
    bots (): KeyDict<Bot> {
      return this.$store.direct.state.bots.bots
    },
    actions (): string[] {
      const actionlist: string[] = []
      Object.values(this.bots).forEach(bot => {
        bot.actions.forEach(action => {
          if (!actionlist.includes(action.type)) {
            actionlist.push(action.type)
          }
        })
      })
      return actionlist
    }
  },
  methods: {
    updateParams () {
      const values: KeyDict<KeyDict<KeyDict<number>>> = {}
      for (const [key, bot] of Object.entries(this.bots)) {
        values[key] = {}
        this.actions.forEach(action => {
          const actionDict = bot.actions.find(a => a.type === action)
          values[key][action] = actionDict !== undefined ? this.getParameters(actionDict) : {}
        })
      }
      this.actionValues = values
    },
    getParameters (action: BotAction): KeyDict<number> {
      const params: KeyDict<number> = {}
      for (const [key, value] of Object.entries(action)) {
        if (typeof value === 'number') {
          params[key] = value
        }
      }
      return params
    },
    save () {
      for (const [id, bot] of Object.entries(this.bots)) {
        const update = { actions: []} as { actions: Partial<BotAction>[] }
        bot.actions.forEach(action => {
          const actionType: string = action.type
          const newaction: Partial<BotAction> = {}
          for (const [param, value] of Object.entries(action)) {
            // @ts-ignore -> the html will turn this into a string
            const newVal = parseFloat(this.actionValues[id][actionType][param])
            if (typeof value === 'number' && value !== newVal) {
              newaction[param] = newVal
            } else {
              newaction[param] = value
            }
          }
          update.actions.push(newaction)
        })
        this.$store.direct.dispatch.bots.updateBot({ botId: id, update })
      }
    },
    newBot () {
      let index = 1
      while (Object.keys(this.bots).includes(`bot_${index}`)) {
        index++;
      }
      this.$store.direct.dispatch.bots.newBot({ castId: this.currentCast.id, name: `bot_${index}` })
    },
    async immediateDumpState () {
      const downloadURL = await this.$store.direct.dispatch.logs.dumpState({requestId: 'bla'})
      console.log('downloadURL', downloadURL)
    }
  },
  components: {
    'el-input': Input,
    'el-button': Button
  }
})
